function t(a) {
  return this.__data__.has(a);
}
var e = t;
export {
  e as default
};
//# sourceMappingURL=_setCacheHas.js.map
